import { z } from 'zod';
import { AppRouter, initContract } from '@ts-rest/core';
import { ObjectIdString } from '@repo/common/schemas';
import { ping } from './shared.js';
import { AccountDTO, OperationDetailDTO, OperationDTO } from '@repo/common/schemas/models';
import { OperationsExportInput, OperationsSearchQuery } from '@repo/common/schemas/api';

const c = initContract();

export const appContractEndpoints = {
  dataIq: {
    operations: {
      search: {
        method: 'GET',
        path: '/dataIq/operations/search',
        query: OperationsSearchQuery,
        responses: {
          200: z.object({
            operations: OperationDTO.array(),
            total: z.number(),
          }),
        },
      },
      byId: {
        method: 'GET',
        path: '/dataIq/operations/:operationId',
        pathParams: z.object({
          operationId: ObjectIdString,
        }),
        responses: {
          200: z.object({
            operation: OperationDetailDTO,
          }),
        },
      },
      exportList: {
        method: 'POST',
        path: '/dataIq/operations/export',
        body: OperationsExportInput,
        responses: {
          200: z.unknown(),
        },
      },
    },
  },
  ping,
} as const satisfies AppRouter;

export const appContract = c.router(appContractEndpoints, {
  pathPrefix: '/app',
  baseHeaders: {
    Authorization: z.string().optional(),
  },
});
